var React = require('react');

function KbdArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 16L13 11.087 8.856 11.087 8.856 0 7.144 0 7.144 11.087 3 11.087z"}));
}

KbdArrowDown.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdArrowDown;

KbdArrowDown.default = KbdArrowDown;
